<template>
    <div class="TenantFeedback">
        <div class="tenantFeedback_title">
            <h3>租戶意見反映</h3>
        </div>
        <div class="inputs">
            <div>
                <small>*</small>
                <label>戶號
                    <input type="text" v-model="house_number" disabled>
                </label>
            </div>
            <div>
                <small>*</small>
                <label>姓名
                    <input type="text" v-model="user_name">
                </label>
            </div>
        </div>
        <div class="inputs">
            <div>
                <small>*</small>
                <label>電話
                    <input type="text" v-model="user_phone">
                </label>
            </div>
            <div>
                <label style="letter-spacing: -1px;">Email
                    <input type="text" v-model="user_email">
                </label>
            </div>
        </div>
        <div class="textarea_div">
            <div>
                <p><small>*</small>反映內容</p>
                <textarea rows="10" cols="70" v-model="content"></textarea>
            </div>
        </div>
        <div class="send_div">
            <button class="send" @click="tenant_send">
                送出
            </button>
            <button class="clear">
                <router-link :to="{ name: 'MemberHome' }">
                    返回
                </router-link>
            </button>
        </div>
        <hr>
        <div class="tenantFeedback_title">
            <h3>歷史意見反映</h3>
        </div>
        <div class="to_tenantFeedback" v-if="tenant_feedback.msg">
            <span>{{tenant_feedback.msg}}</span>
        </div>
        <div class="tenantFeedback_main" v-else>
            <div>
                <div class="tenantFeedback_main_title">
                    <span>意見內容</span>
                    <span>回復內容</span>
                </div>
                <div class="tenantFeedback_main_content" v-for="feedback in tenant_feedback" :key="feedback.id">
                    <div><small>反映人：{{feedback.user_name}}&emsp;反映時間：{{feedback.create_time}}</small></div>
                    <textarea disabled :placeholder="feedback.content"></textarea>
                    <textarea disabled :placeholder="feedback.reply_content"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/css/member/tenantFeedback.css";
export default {
    name: 'TenantFeedback',
    data() {
        return {
            house_number: localStorage.getItem('house_number').toUpperCase(),
            user_name: '',
            user_phone: '',
            user_email: '',
            content: '',
            tenant_feedback: [],
        };
    },
    beforeMount: function () {
        const getData = new FormData();
        getData.append('CMD', 'FrontMemberHomeTenantFeedback');
        getData.append('house_number', this.house_number.toUpperCase());
        getData.append('type', 'getData');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, getData)
        .then(response => {
            // console.log(response);
            const get_datas = response.data.tenant_feedback;
            if (get_datas.error) {
                console.log(get_datas.error);
                this.tenant_feedback = get_datas.msg;
            } else {
                this.tenant_feedback = get_datas;
            }
            const user_data = response.data.user_data;
            if (user_data.error) {
                console.log(user_data.error);
            } else {
                this.user_name = user_data.user_name;
                this.user_phone = user_data.user_phone;
                this.user_email = user_data.user_email;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        tenant_send () {
            if (this.house_number == '' || this.user_name == '' || this.user_phone == '' || this.content == '') {
                alert('請輸入相關資料');
            } else {
                var yes_up = confirm('你確定送出嗎?');
                if (yes_up) {
                    const inserData = new FormData();
                    inserData.append('CMD', 'FrontMemberHomeTenantFeedback');
                    inserData.append('house_number', this.house_number.toUpperCase());
                    inserData.append('type', 'inserData');
                    inserData.append('user_name', this.user_name);
                    inserData.append('user_phone', this.user_phone);
                    inserData.append('user_email', this.user_email);
                    inserData.append('content', this.content);
                    this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, inserData)
                    .then(response => {
                        // console.log(response);
                        if (response.data.result == true) {
                            alert('送出成功');
                            this.$router.push({ name: 'MemberHome' });
                        } else {
                            alert(response.data.error);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
                }
            }
        }
    }
}
</script>